import { render, staticRenderFns } from "./NewQuestion.vue?vue&type=template&id=523d30b4&scoped=true&"
import script from "./NewQuestion.vue?vue&type=script&lang=js&"
export * from "./NewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NewQuestion.vue?vue&type=style&index=0&id=523d30b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523d30b4",
  null
  
)

component.options.__file = "NewQuestion.vue"
export default component.exports